import { useEffect } from 'react';
import { useExercisesInfiniteQuery } from '@src/api/api-hooks/exercises/useExercisesInfiniteQuery.ts';

export interface VideoListParams {
  search?: string;
  tags?: string;
  partitions?: string;
  library: boolean;
  setTitles: (titles: string[]) => void;
}

export const useVideoList = ({ setTitles, ...params }: VideoListParams) => {
  const { data, ...rest } = useExercisesInfiniteQuery({
    search: params?.search || undefined,
    tags: params?.tags || undefined,
    partitions: params?.partitions || undefined,
    library: String(params.library),
  });

  useEffect(() => {
    if (data) {
      const titlesList = data.results.map((video) => video.title);
      setTitles(titlesList);
    }
  }, [data]);

  return {
    videos: data?.results || [],
    ...rest,
  };
};
